import actions from './actions';

const initialState = {
  properties: [],
  activePropertyId: null,
  agent: null,
  welcomeDismissed: false,
  selectedPrpertyModalDismissed: false,
  restoringProperty: true
};

export default function propertyReducer(state = initialState, action) {
  switch (action.type) {
    case actions.STORE_PROPERTIES:
      return {
        ...state,
        properties: action.properties,
      };
    case actions.CHANGE_ACTIVITY:
      return {
        ...state,
        activePropertyId: action.activePropertyId
      };
    case actions.CHANGE_AGENT:
      return {
        ...state,
        agent: action.agent
      };
    case actions.SET_WELCOME_DISMISSED:
      return {
        ...state,
        welcomeDismissed: true,
      };  
    case actions.SET_SELECTED_PROPERTY_MODAL_DISMISSED:
      return {
        ...state,
        selectedPrpertyModalDismissed: true,
      };
    case actions.SET_RESTORING_PROPERTY:
      return {
        ...state,
        restoringProperty: action.restoring,
      };
    default:
      return state;
  }
}
